// ./src/components/inputs/InputCheckBox/styles.ts
import { Checkbox, FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div``;

export const Label = styled(FormControlLabel)``;

export const CheckBox = styled(Checkbox)``;
